<template>
  <el-container class="pagination-list doing-task">
    <el-main>
      <div class="content">
        <el-form :inline="true" :model="process" ref="process" @keyup.enter.native="search">
         <el-form-item prop="processState" label="流程状态">
            <el-select v-model="process.processState" @change="search" placeholder="请选择流程状态" clearable>
              <el-option
                v-for="option in processStates"
                :key="option.key"
                :value="option.key"
                :label="option.text"
              ></el-option>
            </el-select>
          </el-form-item>
          <!--64期晟融流程类型需求-1544-->
          <el-form-item label="流程分类" v-if="tenantId==='16DB9E8F-4B50-003D-9ED7-32C247B72173'">
            <el-select placeholder="请选择流程分类"  v-model="selectedProcess" value-key="name" @change="getTableData" filterable clearable >
            <el-option v-for="item in selectedProcessList" :label="item.name" :value="item.name" :key="item.id"></el-option>
          </el-select>
          </el-form-item>
          <el-form-item label="关键字" prop="keyword">
            <el-input v-model="process.keyword" placeholder="请输入关键字" clearable/>
          </el-form-item>
          <!--操作按钮-->
          <el-form-item class="process-operation-buttons">
            <el-button @click="search">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table class="table-list" :data="items" v-loading="loading" height="100%">
          <el-table-column property="processTitle" label="流程信息" align="center" show-overflow-tooltip></el-table-column>
          <!--64期晟融流程类型需求-1544-->
          <el-table-column property="name" label="流程类型" align="center" v-if="tenantId==='16DB9E8F-4B50-003D-9ED7-32C247B72173'"></el-table-column>
          <el-table-column
            property="startedTime"
            label="开始时间"
            :formatter="formatDate"
            align="center">
          </el-table-column>
          <el-table-column
            property="endTime"
            label="结束时间"
            :formatter="formatDate"
            align="center">
          </el-table-column>
          <el-table-column property="taskName" label="当前节点" align="center"></el-table-column>
          <el-table-column property="taskAssignee" label="当前处理人" align="center"></el-table-column>
          <el-table-column property="status" label="流程状态" align="center"></el-table-column>
          <el-table-column fixed="right" label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button type="text" @click="viewTask(scope.row,'viewAll')">查看</el-button>
              <el-button
                type="text"
                @click="recallTask(scope.row)"
                :disabled="scope.row.status !== '进行中' || scope.row.type === 'cc'"
              >撤回</el-button>
              <el-button type="text" @click="stateView(scope.row)">状态</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-footer height="32px" class="pagination-footer">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-sizes="pagination.pageSizes"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
          ></el-pagination>
        </el-footer>
        <approval-comment
          :dialogVisible="commentVisible"
          :approvalCommentHistory="approvalCommentHistory"
          :currentNodeId="currentNodeId"
          :checkRestrict="checkRestrict"
          @close="commentVisible=false"
          @viewState="viewTask"></approval-comment>
      </div>
    </el-main>
    <dialog-form-runtime @openDialog="openDialog" :formRuntimeDialog="formRuntimeDialog"></dialog-form-runtime>
  </el-container>
</template>

<script>
import moment from 'moment'
import ApprovalComment from './approval-comment'
import {processtMixin, processViewMixin} from './mixin'
import CookieOperation from '@/plugins/cookie'
import DialogFormRuntime from '@/components/shared/dialog-form-runtime.vue'
export default {
  components: {
    ApprovalComment,
    DialogFormRuntime
  },
  mixins: [processtMixin, processViewMixin],
  name: 'ProcessDoneTasks',
  provide () {
    return {
      initCount: this.initCount
    }
  },
  data () {
    return {
      process: {keyword: '', processState: ''},
      processStates: [{
        text: '全部'
      }, {
        key: '1',
        text: '进行中'
      }, {
        key: '2',
        text: '已完成'
      }, {
        key: '3',
        text: '已终止'
      }, {
        key: '4',
        text: '已作废'
      }],
      pagination: {currentPage: 1, pageSize: 20, pageSizes: [10, 20, 30, 50, 100], total: 0},
      loading: false,
      items: [],
      instanceId: '',
      filters: {},
      initCount: {value: 0},
      showOpenDialog: false,
      tenantId: '',
      selectedProcess: '',
      selectedProcessList: []
    }
  },
  watch: {
    'pagination.currentPage' (val) {
      this.getTableData()
    },
    'pagination.pageSize' (val) {
      this.getTableData()
    }
  },
  async created () {
    this.tenantId = CookieOperation.get('tenantId')
    if (this.tenantId === '16DB9E8F-4B50-003D-9ED7-32C247B72173') {
      await this.loadSelectedProcess()
    }
    await this.getTableData()
  },
  methods: {
    // 获取可选择的流程分类名称
    loadSelectedProcess () {
      this.pagination.currentPage = 1
      // 晟融单独接口
      if (this.tenantId === '16DB9E8F-4B50-003D-9ED7-32C247B72173') {
        this.$axios.get('/process-api/processes/categorys4Shengr').then(res => {
          this.selectedProcessList = res.data
        })
      } else {
        this.$axios.get('/process-api/processes/categorys').then(res => {
          this.selectedProcessList = res.data
        })
      }
    },
    search () {
      this.pagination.currentPage = 1
      this.filters = {
        'keyword': this.process.keyword,
        'processState': this.process.processState
      }
      this.getTableData()
    },
    viewTask (row, type) {
      if (type) {
        this.$router.push({ name: 'process-view', params: { instanceId: row.id, nodeId: row.nodeId } })
      } else {
        this.showOpenDialog = true
        this.commentVisible = false
        this.$router.push({ name: 'process-view', params: { instanceId: this.approvalInstanceId, currentNodeId: row, nodeId: row.nodeId } })
      }
    },
    openDialog () {
      if (this.showOpenDialog) {
        this.commentVisible = true
        this.showOpenDialog = false
      }
    },
    recallTask (row) {
      this.$prompt('撤回理由:', '撤回流程', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'publishMessageBox urgeMessageBox recallMessageBox',
        inputPattern: /^.{5,100}$/,
        inputErrorMessage: '请输入撤回理由(长度限制5-100).',
        center: true
      }).then((data) => {
        this.$axios.post('/process-api/runtime/recallTask', {taskId: row.taskId, 'message': data.value})
          .then((res) => {
            this.$message({
              showClose: true,
              message: '流程撤回成功',
              type: 'success'
            })
            this.getTableData()
          })
      }).catch(() => {
      })
    },
    formatDate (row, column) {
      var data = row[column.property]
      if ((column.property === 'startedTime' || column.property === 'endTime') && data) {
        return moment(data).format('YYYY-MM-DD HH:mm')
      }
      return data
    },
    getTableData () {
      this.loading = true
      let page = this.pagination
      if (this.selectedProcess === '') {
        this.filters = {
          'keyword': this.process.keyword,
          'processState': this.process.processState
        }
      } else {
        this.filters = {
          'keyword': this.process.keyword,
          'processState': this.process.processState,
          'name': this.selectedProcess
        }
      }
      let params = {
        'index': page.currentPage,
        'size': page.pageSize,
        'filters': this.filters
      }
      this.$axios.get('/process-api/runtime/doneTasks', {params})
        .then((res) => {
          this.pagination.total = res.data.total
          if ((this.pagination.currentPage - 1) * this.pagination.pageSize >= this.pagination.total) {
            this.pagination.currentPage--
            return
          }
          this.items = res.data.items
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
    }
  }
}
</script>

<style lang="scss">
 @import '@/assets/scss/common.scss';
 .recallMessageBox{
   .el-message-box__errormsg {
     text-align: left;
   }
 }
</style>



// WEBPACK FOOTER //
// src/components/process/runtime/process-doneTasks.vue